var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.8C2 5.35817 2.35817 5 2.8 5H21.2C21.6418 5 22 5.35817 22 5.8C22 7.56731 20.5673 9 18.8 9H12.75V13.6521H15.5C15.9142 13.6521 16.25 13.9879 16.25 14.4021C16.25 14.8163 15.9142 15.1521 15.5 15.1521H12.75V16.7781C12.9057 17.3314 13.2645 18.0766 13.8335 18.6013C14.3936 19.1179 15.1703 19.442 16.2959 19.1237C16.6945 19.011 17.109 19.2428 17.2217 19.6413C17.3344 20.0399 17.1027 20.4544 16.7041 20.5671C15.0297 21.0406 13.723 20.5399 12.8165 19.704C12.4924 19.405 12.2218 19.0666 12 18.7202C11.7782 19.0666 11.5076 19.405 11.1835 19.704C10.277 20.5399 8.9703 21.0406 7.29593 20.5671C6.89734 20.4544 6.66559 20.0399 6.7783 19.6413C6.89101 19.2428 7.30549 19.011 7.70407 19.1237C8.8297 19.442 9.60637 19.1179 10.1665 18.6013C10.7355 18.0766 11.0943 17.3314 11.25 16.7781V15.1521H8C7.58579 15.1521 7.25 14.8163 7.25 14.4021C7.25 13.9879 7.58579 13.6521 8 13.6521H11.25V9H5.2C3.43269 9 2 7.56731 2 5.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantTable);
export default __webpack_public_path__ + "static/media/restaurant-table.31ab836536d1f019815dc99eb237728e.svg";
export { ForwardRef as ReactComponent };